import { useRoutes } from "react-router-dom";
import PrimaryRouting from "./PrimaryRouting";

const PrimaryRouteProvider = () => {
  return useRoutes([...PrimaryRouting]);
};
export default PrimaryRouteProvider;
